import React, { useState, useEffect } from 'react';
import ComponentCategoryList from './ComponentCategoryList';
import ComponentCategoryForm from './ComponentCategoryForm';
import axios from 'axios';
import safeStorage from '../../utils/safeStorage';

// API URL configuration - uses relative URL in production (nginx proxies to backend)
const API_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' && window.location.port === '3002'
    ? 'http://localhost:3000/api'
    : '/api');

const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use(config => {
  const token = safeStorage.getItem('authToken');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

const ComponentCategoryScreen = () => {
  const [categories, setCategories] = useState([]);
  const [editingCategory, setEditingCategory] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [filters, setFilters] = useState({
    category_name: '',
    category_description: ''
  });

  const fetchCategories = async () => {
    const params = {};
    Object.keys(filters).forEach(key => {
      if (filters[key]) params[key] = filters[key];
    });
    const res = await api.get('/component_categories', { params });
    setCategories(res.data);
  };

  useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line
  }, [filters]);

  const handleCreate = () => {
    setEditingCategory(null);
    setShowForm(true);
  };

  const handleEdit = category => {
    setEditingCategory(category);
    setShowForm(true);
  };

  const handleDelete = async id => {
    await api.delete(`/component_categories/${id}`);
    fetchCategories();
  };

  const handleSave = async formData => {
    if (editingCategory) {
      await api.put(`/component_categories/${editingCategory.component_category_id}`, formData);
    } else {
      await api.post('/component_categories', formData);
    }
    fetchCategories();
    setShowForm(false);
    setEditingCategory(null);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingCategory(null);
  };

  const handleFilterChange = (field, value) => {
    setFilters(f => ({ ...f, [field]: value }));
  };

  return (
    <div>
      <h1>Component Categories</h1>
      <button onClick={handleCreate}>Create New Category</button>
      {showForm && (
        <ComponentCategoryForm
          category={editingCategory}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      )}
      <ComponentCategoryList
        categories={categories}
        filters={filters}
        onFilterChange={handleFilterChange}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default ComponentCategoryScreen;